import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { Flag } from 'lucide-react';
import { useAuthStore } from '../../../store/useAuthStore';
import { triggerLightHaptic } from '../../../lib/haptics';
import { APP_PROFILE_JELLY_TOGGLE_ON_STYLE } from '../../../lib/modalTheme';

interface Props {
  plain?: boolean;
}

export const DailyGoalToggle: React.FC<Props> = ({ plain = false }) => {
  const { t } = useTranslation();
  const { preferences, updatePreferences } = useAuthStore();
  const enabled = preferences.dailyGoalEnabled;

  return (
    <div className={plain ? 'px-4 py-2.5' : 'rounded-2xl border border-white/65 bg-[#F7F9F8] px-4 py-2.5 [box-shadow:inset_0_1px_1px_rgba(255,255,255,0.75),0_8px_24px_rgba(148,163,184,0.12)]'}>
      <div className="flex items-center justify-between gap-3">
        <div className="flex-1 min-w-0">
          <div className="flex items-start space-x-2.5">
            <Flag size={18} strokeWidth={2} className="mt-0.5 text-[#000000]" />
            <div className="min-w-0">
              <p className="app-item-title text-black">{t('profile_daily_goal')}</p>
              <p className="app-description mt-0.5 font-light leading-tight text-slate-500">{t('profile_daily_goal_desc')}</p>
            </div>
          </div>
        </div>
        <button
          onClick={() => {
            triggerLightHaptic();
            updatePreferences({ dailyGoalEnabled: !enabled });
          }}
          className="app-hit-target-44 relative w-9 h-5 rounded-full border border-transparent transition-colors"
          style={enabled ? APP_PROFILE_JELLY_TOGGLE_ON_STYLE : { background: '#cbd5e1' }}
        >
          <motion.div
            animate={{ x: enabled ? 16 : 2 }}
            className="absolute left-0 w-4 h-4 rounded-full bg-white shadow-sm"
            style={{ top: '50%', marginTop: '-8px' }}
          />
        </button>
      </div>
    </div>
  );
};
